import React, { useEffect, useState } from "react";
import styles from "./showStars.module.css";
import Section from "../Section";
import { Modal } from "antd";
import ScheduleCourtesy from "../../scheduleCourtesy/scheduleCourtesy";

const ShowStars = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    /*
    // Add any JavaScript logic here
    const button = document.getElementById("sound");
    const videos = document.querySelectorAll(".landingVideo");
    const volumeOff = document.getElementById("volume_off");
    const volumeOn = document.getElementById("volume_on");

    button.onclick = function () {
      volumeOff.style.display =
        window.getComputedStyle(volumeOff).display === "none"
          ? "block"
          : "none";
      volumeOn.style.display =
        window.getComputedStyle(volumeOn).display === "none" ? "block" : "none";

      videos.forEach((video) => {
        if (window.getComputedStyle(video).display !== "none")
          video.muted = !video.muted;
      });
    };

    // Intersection Observer for videos
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    }, options);

    const targets = document.querySelectorAll(".landingVideo");
    targets.forEach((target) => observer.observe(target));
    */
    const scheduleCourtesyButton = document.getElementById("schedule-courtesy");
    if (scheduleCourtesyButton) {
      setTimeout(() => {
        scheduleCourtesyButton.style.display = "block";
        scheduleCourtesyButton.classList.add("fade-in");
      }, 2000);
    }
  }, []);

  const Banner = () => {
    return (
      <div class="w-100 text-center p-5 bg-brand">
        <h3>BIENVENIDOS A LA MEJOR ACADEMIA DE BAILE</h3>
      </div>
    );
  }

  const Why = () => {
    return (
      <div className="section text-center p-5 d-flex flex-column flex-md-row" style={{backgroundColor: "black", color: "white"}}>
          <h1>¿Por qué elegir nuestra academia?</h1>
          <div className="m-auto d-flex flex-grow-1 h-100">
            <h4 className="m-auto">Ofrecemos clases para todos los niveles con instructores profesionales en un ambiente amigable y motivador.</h4>
          </div>
      </div>
    );
  }

  return (
    <>
      <div id="welcome" className="flex-center full-height position-relative">
        <div className="content h-100 w-100">
          <div className="title h-100 w-100">
            <picture className="d-flex h-100 w-100" style={{background: "white" }}>
              <source
                media="(max-width: 768px)"
                srcSet="/img/landing/showStars/mobile_landing.jpg"
              />
              <img
                src="/img/landing/showStars/desktop_landing.jpg"
                alt="Landing Page"
                className="img-fluid m-auto desktop-adjusment"
              />
            </picture>
            {/* 
            <video
              autoPlay
              muted
              className="portrait-video landingVideo"
              src="/assets/video/landing_page_portrait.mp4"
              preload="auto"
            ></video>
            <video
              muted
              className="landscape-video landingVideo"
              src="/assets/video/landing_page_portrait.mp4"
              preload="none"
            ></video>
            */}
            <button
              id="schedule-courtesy"
              className={`${styles.scheduleCourtesy} btn ml-auto mr-auto`}
              onClick={() => setShowModal(true)}
            >
              ¡Baila con nosotros!
            </button>
            {/*
            <button
              id="sound"
              className="btn position-absolute bg-dark text-white"
              style={{
                bottom: "5vh",
                left: "5vh",
                height: "40px",
                lineHeight: 0,
              }}
            >
              <span
                id="volume_off"
                className="material-icons"
                style={{ fontSize: "smaller" }}
              >
                volume_off
              </span>
              <span
                id="volume_on"
                className="material-icons"
                style={{ fontSize: "smaller", display: "none" }}
              >
                volume_up
              </span>
            </button>
            */}
          </div>
        </div>
      </div>
      <div>
        <Banner />
        <Why />
        <Section
          title={"Danza Contemporánea"}
          description={"Explora la libertad de movimiento y la expresión corporal en una fusión de estilos."}
          img={"/img/landing/showStars/danzacontemporeanea.png"}
          background={"#BC9A2F"}
          color={"white"}
        />
        <Section
          title={"Hip Hop"}
          description={"Ritmo urbano, energía y actitud en coreografías llenas de estilo y creatividad."}
          img={"/img/landing/showStars/hiphop.png"}
          background={"#000000"}
          color={"white"}
        />
        <Section
          title={"Salsa y Bachata"}
          description={"Aprende los movimientos y la pasión de los ritmos latinos más populares."}
          img={"/img/landing/showStars/salsaybachata.jpg"}
          background={"#BC9A2F"}
          color={"white"}
        />
        <Section
          title={"Twerk y Dancehall"}
          description={"Explora la potencia del movimiento con estos estilos urbanos llenos de energía."}
          img={"/img/landing/showStars/twerkydancehall.jpg"}
          background={"#000000"}
          color={"white"}
        />
        <Section
          title={"Danza Urbana"}
          description={"Un mix de estilos urbanos para coreografías enérgicas y modernas."}
          img={"/img/landing/showStars/danzaurbana.jpg"}
          background={"#BC9A2F"}
          color={"white"}
        />
      </div>
      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <ScheduleCourtesy />
      </Modal>
    </>
  );
};

export default ShowStars;
